import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class LocationService {

  private directionsService = new google.maps.DirectionsService();

  public getPosition(): Observable<any> {
    return new Observable(obs => {
      window.navigator.geolocation.getCurrentPosition(
        position => {
          obs.next(position);
          obs.complete();
        },
        error => {
          obs.error(error);
        }
      );
    });
  }

  getDirections(
    origin: google.maps.LatLngLiteral, 
    destination: google.maps.LatLngLiteral
  ): Promise<google.maps.DirectionsResult | null> {
    
    const request: google.maps.DirectionsRequest = {
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING,
    };

    return new Promise((resolve, reject) => {
      this.directionsService.route(request, (result, status) => {
        if (status === 'OK' && result) {
          resolve(result);
          console.log('Directions result:', result);
        } else {
          console.error('Directions request failed due to ' + status);
          resolve(null); // Resolve with null on error
        }
      });
    });
  }

  public async calculateDrivingTimeAndLength(
    origin: google.maps.LatLngLiteral,
    destination: google.maps.LatLngLiteral
  ): Promise<{duration: number, distance: number} | null> {

    const result = await this.getDirections(origin, destination);
    if (result && result.routes.length > 0) {
      const leg = result.routes[0].legs[0];
      console.log(leg);
      const duration = leg.duration ? leg.duration.value : 0;
      const distance = leg.distance ? leg.distance.value : 0;
      return { duration: duration, distance: distance };
    }
    return null;
  }

  public async calculateDrivingTimeAndLengthFormatted(
    origin: google.maps.LatLngLiteral,
    destination: google.maps.LatLngLiteral
  ): Promise<{duration: string, distance: string} | null> {

    const result = await this.getDirections(origin, destination);
    if (result && result.routes.length > 0) {
      const leg = result.routes[0].legs[0];
      console.log(leg);
      const duration = leg.duration ? leg.duration.text : "UNKNOWN DURATION";
      const distance = leg.distance ? leg.distance.text : "UNKNOWN DISTANCE";
      return { duration: duration, distance: distance };
    }
    return null;
  }

}

       


